import Header from './Header';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-[1200px] mx-auto">
        <Header />
        <main className="px-4">
          {children}
        </main>
      </div>
    </div>
  );
} 